import { render, staticRenderFns } from "./RestaurarBackup.vue?vue&type=template&id=e0765f8c&"
import script from "./RestaurarBackup.vue?vue&type=script&lang=js&"
export * from "./RestaurarBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports